import { cn } from "@/lib/utils";

export const fieldInputClass =
  "h-8 w-full rounded-md border border-gray-300 px-3 text-xs outline-none focus:border-blue-500";

export const cnInput = (...extras: (string | undefined)[]) =>
  cn(fieldInputClass, ...extras);
